// extracted by mini-css-extract-plugin
export default {"buyer-vendor-view":"buyer-vendor-view_buyer-vendor-view__VMZyI","buyer-vendor-view-body":"buyer-vendor-view_buyer-vendor-view-body__VBydP"};